import { FLOW_UNIT, DATE_UNIT_V, FORMAT_TYPES } from '@src/constants'
import * as Enum from '@src/constants'
import { PageCodes } from '@constants/auth'
import { userStore } from '@src/store/userStore';
import intl from './intl'
import { createHashHistory } from 'history'
import moment from 'moment'

/*
* 深拷贝
* */
export function deepClone(obj) {
    if (!obj) {
        return ''
    }
    return JSON.parse(JSON.stringify(obj))
}

/*
* avatar
* */
export function avatarFunc(customChannel?) {
    const avatar = (window as any).Avatar = (window as any).Avatar || [];
    (window as any).STARTTIME = new Date().getTime();
    const pageTmp = window.location.hash;
    const pageId = pageTmp.substr(1, pageTmp.length);
    let channelTmp = document.referrer;
    let channel = null;
    // 获取安卓手机信息
    const getAndroidInfo = () => {
        const Sys = {} as any;
        const ua = navigator.userAgent.toLowerCase();
        const re = /(android).*?([\d.]+)/;
        const m = ua.match(re);
        if (m == null) {
            Sys.browser = 'other Android OS';
            Sys.ver = '0.0';
        } else {
            Sys.browser = m[0];
            Sys.ver = m[2];
        }
        return Sys;
    }
    // 获取苹果手机信息
    const getIPhoneInfo = () => {
        const Sys = {} as any;
        const ua = navigator.userAgent.toLowerCase();
        const re = /(cpu iphone os|cpu os).*?([\d_]+)/;
        const m = ua.match(re);
        if (m === null) {
            Sys.browser = 'other iPhone OS';
            Sys.ver = '0_0';
        } else {
            Sys.browser = m[0];
            Sys.ver = m[2];
        }
        return Sys;
    }
    // 获取浏览器信息
    const getBrowserInfo = () => {
        const Sys = {} as any;
        const ua = navigator.userAgent.toLowerCase();
        const re = /(maxthon|chrome|msie|firefox|opera|qqbrowser|version).*?([\d.]+)/;
        const m = ua.match(re);
        if (m === null) {
            Sys.browser = 'other browsers';
            Sys.ver = '0.0';
        } else {
            Sys.browser = m[1].replace(/version/, 'safari');
            Sys.ver = m[2];
        }
        return Sys;
    }

    const curDomain = document.domain;
    if (channelTmp.indexOf('aoac') > -1) {
        channelTmp = '';
    }
    if (channelTmp == null || channelTmp === '') {
        channel = 'lenovo';
    } else {
        channel = channelTmp;
    }

    // 设备(浏览器或手机)型号 , 版本号
    let sys = {} as any;
    let deviceModel = '';
    let versionCode = '';
    if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) { // iPhone,iPad,iPod,iOS
        // 获取当前的苹果手机信息
        sys = getIPhoneInfo();
        // sys.browser得到手机的类型，sys.ver得到手机的版本
        deviceModel = sys.browser;
        versionCode = sys.ver;
    } else if (/(Android)/i.test(navigator.userAgent)) { // Android
        // 获取当前的安卓手机信息
        sys = getAndroidInfo();
        // sys.browser得到手机的类型，sys.ver得到手机的版本
        deviceModel = sys.browser;
        versionCode = sys.ver;
    } else { // PC端浏览器
        // 获取当前的浏览器信息
        sys = getBrowserInfo();
        // sys.browser得到浏览器的类型，sys.ver得到浏览器的版本
        deviceModel = sys.browser;
        versionCode = sys.ver;
    }
    ;

    avatar.push({
        appKey: '647HLU8G0JD2',
        pageId: pageId,
        throttle: 0,
        channel: customChannel || channel,
        deviceModel: deviceModel,
        startTime: (window as any).STARTTIME,
        trackStayTime: true,
        delay: 100,
        versionCode: versionCode,
        cookieDomain: curDomain,
        init: () => {
            console.log('初始化完成');
        }
    });
}

/*
* 去抖函数debounce
* */
export function debounce(fn, delay, param) {
    let timer
    if (timer) {
        clearTimeout(timer)
    }
    timer = setTimeout(() => {
        fn(param)
    }, delay)
}

/*
* 节流函数throttle
* */
export function throttle(func, delay) {
    let previous = 0 // 使用闭包
    return () => {
        const now = +new Date()
        if (!previous) {
            previous = now
        }
        if (now - previous > delay) {
            func()
            previous = now
        }
    }
}

/*
* 枚举视图显示过滤
* */
export function enumToView(enums: string, value: any): string {
    const keys = Object.keys(Enum[enums + '_V']).filter((item) => {
        return Enum[enums + '_V'][item].toString() === value
    })
    return (keys.length > 0) ? Enum[enums][keys[0]] : ''
}

/*
* 流量单位过滤器
* */
export function filterFlowUnit(flow: number = 0, returnObj: boolean = false): any {
    const flowRes = { value: Number(flow) || 0, unit: FLOW_UNIT.KB }
    let negative = false;
    if (flowRes.value < 0) {
        negative = true;
        flowRes.value = 0 - flowRes.value
    }
    switch (true) {
        case 0 < flowRes.value && flowRes.value < Math.pow(1024, 1):
            break
        case Math.pow(1024, 1) <= flowRes.value && flowRes.value < Math.pow(1024, 2):
            flowRes.value = flowRes.value / Math.pow(1024, 1)
            flowRes.unit = FLOW_UNIT.MB
            break
        case Math.pow(1024, 2) <= flowRes.value && flowRes.value < Math.pow(1024, 3):
            flowRes.value = flowRes.value / Math.pow(1024, 2)
            flowRes.unit = FLOW_UNIT.GB
            break
        case Math.pow(1024, 3) <= flowRes.value && flowRes.value < Math.pow(1024, 4):
            flowRes.value = flowRes.value / Math.pow(1024, 3)
            flowRes.unit = FLOW_UNIT.TB
            break
        case Math.pow(1024, 4) <= flowRes.value:
            flowRes.value = flowRes.value / Math.pow(1024, 4)
            flowRes.unit = FLOW_UNIT.PB
            break
        default:
            break
    }
    flowRes.value = !negative ? Number(flowRes.value.toFixed(2)) : 0 - Number(flowRes.value.toFixed(2))
    if (!returnObj) {
        return `${flowRes.value}${flowRes.unit}`
    }
    return flowRes
}

export function createRandomCode() {
    let code = ''
    const codeLength = Math.floor(Math.random() * 10 + 8)
    const random = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
    for (let i = 0; i < codeLength; i++) {
        const index = Math.floor(Math.random() * 62)
        code += random[index];
    }
    return code;
}

/*
* 格式化价格-输出
* */
export function getFormatPrice(value) {
    if (!value && String(value) !== '0') {
        return value || '0'
    }
    return Number(value) === 0 ? 0 : (Number(value) / 100).toFixed(2)
}

/*
 * 尚未登录去首页
 * */
export function needLogin() {
    const userInfo = userStore.userInfo
    if (!userInfo.lenovoId) {
        window.location.href = '#/login'
        return true
    } else {
        return false
    }
}

/*
 * 打开URL or URI
 * */
export function openURI(url) {
    if (!url) {
        return
    }
    if (url.indexOf('ms-')) {
        window.location.href = '#/open-app'
    } else if (url.indexOf('//') === -1) {
        window.location.href = `https://${url}`
    } else {
        window.location.href = url
    }
}

// 判断空对象
export const isEmptyObject = (obj) => JSON.stringify(obj) === '{}'

// 判断浏览器环境
export function isWeixin(): boolean {
    const wx = navigator.userAgent.toLowerCase() as any
    return wx.indexOf('micromessenger') > -1
}

// 判断 Iphone系统版本
export const getIOSVersion = (): string => {
    const params = navigator.userAgent.toLowerCase();
    const _params = params.match(/cpu iphone os (.*?) like mac os/);
    return !_params ? '' : _params[1].replace(/_/g, '.') // "11.0"
}

export const isIOS = () => {
    const u = navigator.appVersion;
    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
}

export const isQQBrowser = () => {
    const u = navigator.appVersion;
    return u.split('MQQBrowser/').length > 1
}

/**
 * 判断  iphone的 型号 根据 屏幕宽度
 */
export const getIPhoneType = () => {
    let type = ''
    if (screen.height === 736 && screen.width === 414) {
        type = '678p'
    } else if (screen.height === 667 && screen.width === 375) {
        type = '678'
    } else if (screen.height === 568 && screen.width === 320) {
        type = '5'
    }
    return type
}
export const calcTotalFeeByCoupon = (couponType, totalFee, worthValue) => {
    let totalFeeByCoupon = null
    switch (couponType) {
        case '0': // 满减券
            totalFeeByCoupon = (Number(totalFee) / 100 - Number(worthValue)).toFixed(2)
            break
        case '1': // 折扣券
            totalFeeByCoupon = (Number(totalFee) / 100 * worthValue / 10).toFixed(2)
            break
    }
    return totalFeeByCoupon < 0.01 ? 0.01 : totalFeeByCoupon
}

export const filterPageByAuthCodes = (actionName) => {
    const authList = localStorage.getItem('authCodes') ? JSON.parse(localStorage.getItem('authCodes')) : []
    return authList.includes(PageCodes[actionName])
}

export function getPackageLength(data) {
    return `${Number(data.timeLength) * Number(data.goodsNumber)}${enumToView(`DATE_UNIT`, data.timeUnit)}`
}

export function getPackageSummary(data: {
    timeUnit: any, timeLength: any, goodsNumber: any, policyDegree: any
}) {
    return `${Number(data.timeLength) * Number(data.goodsNumber)}${data.timeUnit === DATE_UNIT_V.MONTH ? 'M' : 'D'}${filterFlowUnit(data.policyDegree)}`
}

/**
 * 生成两个数范围内的随机整数
 */
export const randomNum = (minNum, maxNum) => {
    return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
}

export function isChinese() {
    return navigator.language.includes('zh')
}

export function decorateTpMth(data: any) {
    if (data.timeUnit === DATE_UNIT_V.DAY && data.timeLength === '30') {
        data.timeUnit = DATE_UNIT_V.MONTH
        data.timeLength = '1'
        return data
    } else {
        return data
    }
}

export function tranlatorTpCycleDayToMth(params) {
    const { timeUnit, timeLength, goodsNumber } = decorateTpMth(params)
    return {
        timeUnit,
        timeLength: timeLength === '1' ? '' : timeLength,
        goodsTime: Number(timeLength) * Number(goodsNumber)
    }
}

export function countTotalFlowData(param) {
    const { goodsNumber, policyDegree } = param
    const valueObj = filterFlowUnit(Number(policyDegree), true)
    return Number(goodsNumber) * Number(valueObj.value) + valueObj.unit
}

export function getLang() {
    const langs = ['zh', 'en', 'de', 'es', 'fr', 'it', 'pt']
    let lang = sessionStorage.getItem('language') || navigator.language
    if (location.hash.indexOf('global') > -1 && lang === 'zh-CN') { // 国际版本暂时不展示中文
        lang = 'en-US'
    }
    const [front] = lang.split('-')
    return !langs.includes(front) ? 'en' : front
}

// 海外日期格式
export function formatDate(value, format = 'date'): any {
    if (!value) {
        return {}
    }
    if (format === 'time') {
        const dateTime = moment(value).subtract(8, 'hours')
        return {
            date: dateTime.format('DD/MM/YYYY'),
            time: dateTime.format('HH:mm'),
            timeDateStr: dateTime.format(FORMAT_TYPES.MINUTE_GLOBAL),
        }
    } else {
        return moment(value).subtract(8, 'hours').format('DD/MM/YYYY')
    }
}

export function getUrlSearch() {
    if (window.location.search.length <= 0) {
        return {}
    }
    const info = window.location.search.slice(1);
    const result = {} as any;
    info.split('&').forEach(item => {
        result[decodeURIComponent(item.split('=')[0])] = decodeURIComponent(item.split('=')[1]);
    });
    return result;
}
export const getUrlParams = () => {
    const query = window.location.hash.split('?')[1];
    const vars = query?.split('&') ?? [];
    const param: any = {};
    vars.forEach((item) => {
        const [key, value] = item.split('=');
        param[key] = value;
    });
    return param;
};
export function isEmail(value: string): boolean {
    const reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
    return reg.test(value)
}

interface Types {
    timeLength: string,
    timeUnit: string
}

export function formatPackageTimeLength(options: Types): any {
    // 30天按一个月来计算
    if (options.timeUnit === '1') {
        return {
            timeLength: Number(options.timeLength) === 30 ? 1 : Number(options.timeLength),
            timeUnit: Number(options.timeLength) === 30 ? '0' : options.timeUnit
        }
    }
    return {
        timeLength: Number(options.timeLength),
        timeUnit: options.timeUnit
    }
}

export function isPC() {
    const userAgentInfo = navigator.userAgent;
    const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
    let flag = true;
    Agents.map((item) => {
        if (userAgentInfo.indexOf(item) > -1) {
            flag = false
        }
    })
    return flag;
}

// 隐藏手机号中间
export function geTel(tel: string) {
    return tel.substring(0, 3) + '****' + tel.substr(tel.length - 4);
}

// 价格逗号隔开
export function formatMoney(s, type = 0) {
    if (/[^0-9\.]/.test(s)) return '0';
    if (s == null || s === '') return '0';
    s = s.toString().replace(/^(\d*)$/, '$1.');
    s = (s + '00').replace(/(\d*\.\d\d)\d*/, '$1');
    s = s.replace('.', ',');
    const re = /(\d)(\d{3},)/;
    while (re.test(s))
        s = s.replace(re, '$1,$2');
    s = s.replace(/,(\d\d)$/, '.$1');
    if (type === 0) {
        const a = s.split('.');
        if (a[1] === '00') {
            s = a[0];
        }
    }
    return s;
}

export function descrToArr(descr) {
    let arr
    if (!!descr) {
        arr = descr.split('\n')
    } else {
        arr = []
    }
    return arr
}

export function bannerClick(url) {
    if (!!url) {
        const arr = url.split('/');
        const activityId = arr[arr.length - 1];
        // 优惠券入口
        if (url.includes('ticket')) {
            createHashHistory().push(`/app/ordering/receiveCoupon/${activityId}`)
        }
        // 抽奖入口
        if (url.includes('lottery')) {
            createHashHistory().push('/app/ordering/lottery')
        }
        // 套餐变更入口
        if (url.includes('change-package')) {
            createHashHistory().push('/app/change-package')
        }
        if (url.includes('blind-box')) {
            createHashHistory().push(`/app/ordering/blind-box`)
        }
        // 新人礼
        if (url.includes('meetingGift')) {
            createHashHistory().push('/app/meetingGift')
        }
    }
}
/**
 * 是否是合法的手机号
 * @param phone
 * @returns
 */
export function isValidPhone(phone: string): boolean {
    if ((/^(13|14|15|16|17|18|19)[0-9]{9}$/).test(phone)) {
        return true
    }
    return false
}

/** IMEI：86 开头的 15 位纯数字 */
export function isValidImei(imei: string): boolean {
    return /^86\d{13}$/.test(imei)
}

// 处理AI聊天消息
export function translatorAiMessage(value) {
    // console.log("进来了啊",value)
    JSON.parse(JSON.stringify(value))
    const dataArray = value.split('data:');
    // console.log("dataArray",dataArray)
    let obj = {
        contents: "",
        isDone: false,
    };
    if (dataArray[dataArray.length - 1].indexOf("[DONE]") > -1) {
        obj.isDone = true;
    } else {
        obj.isDone = false;
    }
    // console.log("obj",obj)
    let str = ''
    for (let i = 0; i < dataArray.length; i++) {
        if (dataArray[i] && dataArray[i].indexOf("DONE") < 0) {
            let result = dataArray[i].match(/content\":\"([^\"]*)\"/);
            if (result && result.length > 1) {
                
                let step1 = result[1].replace(/\\n\\n/g, '<br>')
                let step2 = step1.replace(/\\n/g, '<br>')
                let step3 = step2.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
                let step4 = step3.replace(/\\/g, "")
                let firstSentenceMatch = str.match(/#(.*?)(\s|,|。|,|!|；|;|？|\?)/);
                if (firstSentenceMatch) {
                    let firstSentence = firstSentenceMatch[1];
                    let step5 = step4.replace(firstSentenceMatch[0], '<h3>' + firstSentence + '</h3>');
                    str+=step5
                } else {
                    str+=step4
                }
            }

        }
    }
    obj.contents = str



    return obj
}